import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconBookmarkFilled = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M3 6.047c0-1.125.39-2.078 1.172-2.86.781-.796 1.726-1.195 2.836-1.195h9.984c1.11 0 2.055.399 2.836 1.196C20.61 3.968 21 4.921 21 6.046v14.93c0 .437-.195.75-.586.937-.39.172-.75.117-1.078-.164l-6-5.414A1.966 1.966 0 0 0 12 15.82c-.5 0-.945.172-1.336.516l-6 5.414c-.328.281-.687.336-1.078.164-.39-.187-.586-.5-.586-.937V6.047z" }),
});

export { IconBookmarkFilled };
